import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  HttpXsrfTokenExtractor,
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";

import { Router } from "@angular/router";

import PNotify from "pnotify/dist/es/PNotify";
import PNotifyButtons from "pnotify/dist/es/PNotifyButtons";

@Injectable()
export class HttpXsrfInterceptor implements HttpInterceptor {
  constructor(
    private tokenExtractor: HttpXsrfTokenExtractor,
    private router: Router
  ) {
    PNotifyButtons; // Initiate the module. Important!
    PNotify.defaults.styling = "bootstrap4"; // Bootstrap version 4
    PNotify.defaults.icons = "fontawesome4"; // Font Awesome 4
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = this.tokenExtractor.getToken() as string;

    console.log("XSRF-TOKEN >>>", token);

    if (!token) {
      this.notifyUser();
      this.router.navigateByUrl("/");
      return next.handle(req);
    }

    req = req.clone({
      headers: req.headers.set("X-XSRF-TOKEN", token),
    });

    return next.handle(req);
  }

  public notifyUser() {
    PNotify.info({
      title: "Askies, Sorry",
      titleTrusted: false,
      text: "We redirected you for security reasons, please continue browsing in or log in again",
      textTrusted: false,

      icon: "fa fa-bell",
      Mobile: {
        swipeDismiss: true,
        styling: true,
      },
      width: "300px",
      delay: 10000,
      buttons: { closer: true, labels: { close: "Fechar", stick: "Manter" } },
      stack: {
        dir1: "down",
        firstpos1: 25,
      },
    });
  }
}
